import { Box } from '@material-ui/core';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface StructureCardWrapperProps {
  type: 'channel' | 'agent' | 'merchant';
  id: string;
  isSelected: boolean;
  children: React.ReactElement;
  onClick?: () => void;
}

export const StructureCardWrapper = ({ onClick, type, id, isSelected, children }: StructureCardWrapperProps) => {
  const { palette } = useCustomTheme();
  return (
    <CustomPaper
      fill="paper"
      id={`${type}-${id}`}
      onClick={onClick}
      style={{
        // transition: 'all 0.2s',
        padding: '2px 2px 2px 8px',
        marginBottom: '8px',
        ...(isSelected && {
          backgroundColor: palette.secondary.main,
        }),
        ...(onClick && { cursor: 'pointer' }),
      }}
    >
      <Box py={'6px'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
        {children}
      </Box>
    </CustomPaper>
  );
};
